import { render, staticRenderFns } from "./ZadiFinish.vue?vue&type=template&id=6a10125b&scoped=true&"
import script from "./ZadiFinish.vue?vue&type=script&lang=js&"
export * from "./ZadiFinish.vue?vue&type=script&lang=js&"
import style0 from "./ZadiFinish.vue?vue&type=style&index=0&id=6a10125b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a10125b",
  null
  
)

export default component.exports